export default __webpack_public_path__ + "static/media/Sagar.09f3dbad.jpeg";